module.exports = __webpack_public_path__ + "img/hip-endomorph-male.6c5c8e83.svg";